(function () {
  if (window.CustomCartUpsellsInit) return;
  window.CustomCartUpsellsInit = true;

  /* ========= helpers ========= */

  function formatMoney(amount, moneyFormat) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(amount, moneyFormat);
    }
    if (typeof moneyFormat === "string" && moneyFormat.indexOf("{{amount}}") !== -1) {
      var num = (amount / 100).toFixed(2);
      return moneyFormat.replace("{{amount}}", num);
    }
    return (amount / 100).toFixed(2);
  }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
      .then(function (r) {
        return r.ok ? r.json() : { items: [] };
      })
      .catch(function () {
        return { items: [] };
      });
  }

  function cartSignature(cart) {
    if (!cart || !cart.items) return "";
    var ids = cart.items
      .map(function (i) {
        return i.product_id + "x" + i.quantity;
      })
      .join("|");
    return cart.item_count + "::" + ids;
  }

  // IMPORTANT: prefer <cart-drawer> first (Dawn native methods live here)
  function getDrawerEl() {
    return (
      document.querySelector("cart-drawer") ||
      document.getElementById("cart-drawer") ||
      document.getElementById("CartDrawer") ||
      document.querySelector("[data-cart-drawer]") ||
      null
    );
  }

  function getDrawerDetailsEl() {
    var drawer = getDrawerEl();

    // cart-drawer is inside <details> in Dawn
    if (drawer && drawer.closest) {
      var d = drawer.closest("details");
      if (d) return d;
    }

    return (
      document.getElementById("Details-cart-drawer-container") ||
      document.querySelector('details[id^="Details-cart-drawer"]') ||
      document.querySelector("details.cart-drawer-container") ||
      null
    );
  }

  function getUpsellsRoot() {
    var roots = document.querySelectorAll("[data-cart-upsells-root]");
    if (!roots || !roots.length) return null;

    // Prefer visible root (avoid template duplicates)
    for (var i = 0; i < roots.length; i++) {
      var el = roots[i];
      if (el && el.getClientRects && el.getClientRects().length) return el;
    }
    return roots[0];
  }

  function getRecommendationsUrl(productId, intent, limit) {
    var root = "/";
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    var base = root.replace(/\/?$/, "/");
    return (
      base +
      "recommendations/products.json?product_id=" +
      encodeURIComponent(productId) +
      "&intent=" +
      encodeURIComponent(intent) +
      "&limit=" +
      encodeURIComponent(limit * 3)
    );
  }

  function fetchRecommendationsForProduct(productId, intent, limit) {
    var url = getRecommendationsUrl(productId, intent, limit);
    return fetch(url, { credentials: "same-origin", cache: "no-store" })
      .then(function (r) {
        return r.ok ? r.json() : { products: [] };
      })
      .catch(function () {
        return { products: [] };
      });
  }

  function updateUpsellPriceFromSelect(selectEl) {
    if (!selectEl) return;

    var card = selectEl.closest(".cart-upsells__item");
    if (!card) return;

    var priceWrap = card.querySelector(".cart-upsells__price");
    if (!priceWrap) return;

    var root = card.closest("[data-cart-upsells-root]");
    var moneyFormat =
      (root && root.getAttribute("data-upsells-money-format")) ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    var opt = selectEl.options[selectEl.selectedIndex];
    if (!opt) return;

    var price = parseInt(opt.getAttribute("data-price") || "0", 10);
    var compareAt = parseInt(opt.getAttribute("data-compare-at") || "0", 10);

    var html = "";
    if (compareAt && compareAt > price) {
      html =
        '<span class="cart-upsells__price-old">' +
        formatMoney(compareAt, moneyFormat) +
        "</span>" +
        '<span class="cart-upsells__price-new">' +
        formatMoney(price, moneyFormat) +
        "</span>";
    } else {
      html =
        '<span class="cart-upsells__price-regular">' + formatMoney(price, moneyFormat) + "</span>";
    }

    priceWrap.innerHTML = html;
  }

  /* ========= upsell cards ========= */

  function buildCardsHtml(products, inCartProductIds, moneyFormat, limit) {
    var usedIds = new Set();
    var picked = [];

    products.forEach(function (p) {
      if (!p || p.available === false) return;
      if (inCartProductIds.indexOf(p.id) !== -1) return;
      if (usedIds.has(p.id)) return;
      if (picked.length >= limit) return;

      usedIds.add(p.id);
      picked.push(p);
    });

    if (!picked.length) return "";

    return picked
      .map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]);
        var imgUrl = null;

        if (img && typeof img === "string") {
          imgUrl = img.replace(/_(\d+x\d+|x\d+)\./, "_160x.");
        } else if (img && img.src) {
          imgUrl = img.src;
        }

        var title = p.title || "";
        var words = title.split(" ").filter(function (w) {
          return w.length;
        });
        var shortWords = words.slice(0, 5);
        var shortTitle = shortWords.join(" ");
        if (words.length > 5) shortTitle += "…";

        var variants = p.variants || [];
        var fav = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i] && variants[i].available) {
            fav = variants[i];
            break;
          }
        }
        if (!fav && variants.length) fav = variants[0] || null;

        var selectedVariant = fav || null;

        var basePrice =
          selectedVariant && selectedVariant.price != null ? selectedVariant.price : p.price;
        var baseCompareAt =
          selectedVariant && selectedVariant.compare_at_price != null
            ? selectedVariant.compare_at_price
            : p.compare_at_price;

        var priceHtml = "";
        if (baseCompareAt && baseCompareAt > basePrice) {
          priceHtml =
            '<span class="cart-upsells__price-old">' +
            formatMoney(baseCompareAt, moneyFormat) +
            "</span>" +
            '<span class="cart-upsells__price-new">' +
            formatMoney(basePrice, moneyFormat) +
            "</span>";
        } else {
          priceHtml =
            '<span class="cart-upsells__price-regular">' +
            formatMoney(basePrice, moneyFormat) +
            "</span>";
        }

        var hasMultipleVariants = variants.length > 1;
        var selectedVariantId = selectedVariant && selectedVariant.id;
        var handle = p.handle || "";
        var productUrl = p.url || (handle ? "/products/" + handle : "#");

        var selectorHtml = "";
        if (hasMultipleVariants) {
          selectorHtml += '<select class="cart-upsells__variant-select" data-upsell-variant-select>';
          variants.forEach(function (v) {
            if (!v) return;
            var optLabel = v.public_title || v.title || "";
            selectorHtml +=
              '<option value="' +
              v.id +
              '"' +
              (selectedVariantId && String(v.id) === String(selectedVariantId) ? " selected" : "") +
              ' data-price="' +
              (v.price || 0) +
              '" data-compare-at="' +
              (v.compare_at_price || 0) +
              '">' +
              optLabel +
              "</option>";
          });
          selectorHtml += "</select>";
        }

        var buttonHtml = "";
        if (!hasMultipleVariants && selectedVariant && selectedVariant.id) {
          buttonHtml =
            '<button type="button" class="cart-upsells__add" data-cart-upsell-add data-variant-id="' +
            selectedVariant.id +
            '"><span class="cart-upsells__add-icon">+</span></button>';
        } else {
          buttonHtml =
            '<button type="button" class="cart-upsells__add" data-cart-upsell-add><span class="cart-upsells__add-icon">+</span></button>';
        }

        return (
          '<div class="cart-upsells__item">' +
          '<a href="' +
          productUrl +
          '" class="cart-upsells__media" data-instant>' +
          (imgUrl
            ? '<img src="' + imgUrl + '" alt="' + shortTitle.replace(/"/g, "&quot;") + '">'
            : "") +
          "</a>" +
          '<div class="cart-upsells__content">' +
          '<a href="' +
          productUrl +
          '" class="cart-upsells__title" data-instant>' +
          shortTitle +
          "</a>" +
          '<div class="cart-upsells__bottom-row">' +
          '<div class="cart-upsells__price">' +
          priceHtml +
          "</div>" +
          (selectorHtml || "") +
          "</div>" +
          "</div>" +
          buttonHtml +
          "</div>"
        );
      })
      .join("");
  }

  /* ========= render upsells ========= */

  var lastSignature = null;
  var updating = false;
  var pendingRender = false;
  var renderTimer = null;

  function scheduleRender() {
    if (updating) {
      pendingRender = true;
      return;
    }
    if (renderTimer) return;
    renderTimer = setTimeout(function () {
      renderTimer = null;
      renderCartUpsells();
    }, 50);
  }

  function renderCartUpsells() {
    if (updating) return;
    updating = true;

    var root = getUpsellsRoot();
    if (!root) {
      updating = false;
      return;
    }

    var listEl = root.querySelector("[data-cart-upsells-list]");
    if (!listEl) {
      updating = false;
      return;
    }

    var intent = root.getAttribute("data-upsells-intent") || "complementary";
    var limit = parseInt(root.getAttribute("data-upsells-limit") || "3", 10);
    var moneyFormat =
      root.getAttribute("data-upsells-money-format") ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    fetchCart()
      .then(function (cart) {
        var sig = cartSignature(cart);

        // If already rendered for this cart state, do nothing
        if (sig === lastSignature && listEl.children.length) {
          updating = false;
          if (pendingRender) {
            pendingRender = false;
            scheduleRender();
          }
          return;
        }
        lastSignature = sig;

        // cart empty -> hide
        if (!cart || !cart.items || !cart.items.length) {
          root.style.display = "none";
          listEl.innerHTML = "";
          updating = false;
          if (pendingRender) {
            pendingRender = false;
            scheduleRender();
          }
          return;
        }

        root.style.display = "";
        listEl.innerHTML = "";

        var inCartProductIds = cart.items.map(function (i) {
          return i.product_id;
        });

        var allRecs = [];
        var productIds = inCartProductIds.slice();
        var idx = 0;

        function step() {
          if (idx >= productIds.length || allRecs.length >= limit * 3) {
            var html = buildCardsHtml(allRecs, inCartProductIds, moneyFormat, limit);

            if (!html) {
              root.style.display = "none";
              listEl.innerHTML = "";
            } else {
              root.style.display = "";
              listEl.innerHTML = html;

              // sync prices for selects
              var selects = listEl.querySelectorAll("[data-upsell-variant-select]");
              selects.forEach(function (sel) {
                updateUpsellPriceFromSelect(sel);
              });
            }

            updating = false;
            if (pendingRender) {
              pendingRender = false;
              scheduleRender();
            }
            return;
          }

          var pid = productIds[idx++];
          fetchRecommendationsForProduct(pid, intent, limit)
            .then(function (data) {
              if (data && Array.isArray(data.products)) {
                allRecs = allRecs.concat(data.products);
              }
              step();
            })
            .catch(function () {
              step();
            });
        }

        step();
      })
      .catch(function () {
        updating = false;
        if (pendingRender) {
          pendingRender = false;
          scheduleRender();
        }
      });
  }

  /* ========= Dawn-friendly drawer observers / hooks ========= */

  function setupDrawerMutationObserver() {
    var drawer = getDrawerEl();
    if (!drawer) return;

    // Dawn: cart-drawer-items / #CartDrawer-CartItems
    var itemsHolder =
      drawer.querySelector("[data-items-holder]") ||
      drawer.querySelector("cart-drawer-items") ||
      drawer.querySelector('[id*="CartDrawer-CartItems"]') ||
      drawer.querySelector("#CartDrawer-CartItems") ||
      drawer;

    if (!itemsHolder) return;

    if (window.CustomCartUpsellsItemsObserver) {
      window.CustomCartUpsellsItemsObserver.disconnect();
    }

    var observer = new MutationObserver(function (muts) {
      var changed = muts.some(function (m) {
        return m.type === "childList" || m.type === "characterData";
      });
      if (changed) scheduleRender();
    });

    observer.observe(itemsHolder, { childList: true, subtree: true, characterData: true });
    window.CustomCartUpsellsItemsObserver = observer;
  }

  function hookDrawerToggle() {
    var details = getDrawerDetailsEl();
    if (!details) return;
    if (details.__customUpsellsToggleHooked) return;
    details.__customUpsellsToggleHooked = true;

    details.addEventListener("toggle", function () {
      if (details.open) {
        setupDrawerMutationObserver();
        scheduleRender();
      }
    });
  }

  /* ========= refresh drawer after add (Dawn native first, fallback second) ========= */

  function refreshDrawerDawnNative() {
    var drawer = getDrawerEl();
    if (!drawer) return Promise.reject();

    if (typeof drawer.getSectionsToRender !== "function" || typeof drawer.renderContents !== "function") {
      return Promise.reject();
    }

    var sections = [];
    try {
      sections = drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    } catch (e) {
      sections = [];
    }

    if (!sections.length) return Promise.reject();

    return fetch("/?sections=" + encodeURIComponent(sections.join(",")), {
      credentials: "same-origin",
      cache: "no-store",
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        if (!json) throw new Error("No sections json");
        try {
          drawer.renderContents({ sections: json });
        } catch (e) {}

        setupDrawerMutationObserver();
        hookDrawerToggle();
        scheduleRender();
      });
  }

  function getCartDrawerSectionIds() {
    var drawer = getDrawerEl();
    if (!drawer) return null;

    var node = drawer;
    while (node && node !== document.documentElement) {
      if (node.id && node.id.indexOf("shopify-section-") === 0) {
        return { domId: node.id, sectionId: node.id.replace("shopify-section-", "") };
      }
      node = node.parentElement;
    }
    return null;
  }

  function refreshCartDrawerFromSectionFallback(detail) {
    var ids = getCartDrawerSectionIds();
    if (!ids) {
      scheduleRender();
      return Promise.resolve();
    }

    var sectionDomId = ids.domId;
    var sectionId = ids.sectionId;

    return fetch("/?sections=" + encodeURIComponent(sectionId), {
      credentials: "same-origin",
      cache: "no-store",
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        if (!json || !json[sectionId]) {
          scheduleRender();
          return;
        }

        var html = json[sectionId];
        var tmp = document.createElement("div");
        tmp.innerHTML = html;

        var freshSection = tmp.querySelector("#" + sectionDomId) || tmp.firstElementChild;
        if (!freshSection) {
          scheduleRender();
          return;
        }

        var freshDrawer =
          freshSection.querySelector("cart-drawer") ||
          freshSection.querySelector("#cart-drawer") ||
          freshSection.querySelector("#CartDrawer");

        var liveDrawer = getDrawerEl();
        if (!freshDrawer || !liveDrawer) {
          scheduleRender();
          return;
        }

        // If live drawer is <cart-drawer>, we should replace its innerHTML, not the element itself
        if (liveDrawer.tagName && liveDrawer.tagName.toLowerCase() === "cart-drawer") {
          liveDrawer.innerHTML = freshDrawer.innerHTML;
        } else {
          liveDrawer.innerHTML = freshDrawer.innerHTML;
        }

        var freshBubble = freshSection.querySelector("#cart-icon-bubble");
        var liveBubble = document.querySelector("#cart-icon-bubble");
        if (freshBubble && liveBubble) {
          liveBubble.innerHTML = freshBubble.innerHTML;
        }

        setupDrawerMutationObserver();
        hookDrawerToggle();

        try {
          var root = document.documentElement || document;
          ["cart:updated", "cart:refresh", "ajaxProduct:added", "product:added"].forEach(function (name) {
            root.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || null }));
          });
        } catch (e) {}

        scheduleRender();
      })
      .catch(function () {
        scheduleRender();
      });
  }

  function refreshCartUI(detail) {
    return refreshDrawerDawnNative()
      .catch(function () {
        return refreshCartDrawerFromSectionFallback(detail);
      })
      .catch(function () {
        scheduleRender();
      });
  }

  /* ========= clicks in upsells ========= */

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-cart-upsell-add]");
    if (!button) return;

    var variantId = button.getAttribute("data-variant-id");

    if (!variantId) {
      var card = button.closest(".cart-upsells__item");
      if (card) {
        var select = card.querySelector("[data-upsell-variant-select]");
        if (select) variantId = select.value;
      }
    }

    if (!variantId) return;

    event.preventDefault();
    button.disabled = true;

    // Dawn-native sections update (so item appears instantly in drawer)
    var drawer = getDrawerEl();
    var sections = null;

    try {
      if (drawer && typeof drawer.getSectionsToRender === "function") {
        sections = drawer.getSectionsToRender().map(function (s) {
          return s.id;
        });
      }
    } catch (e) {}

    if (!sections || !sections.length) {
      // safe fallback
      sections = ["cart-drawer", "cart-icon-bubble"];
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (state) {
        button.disabled = false;

        // If we got sections, render drawer immediately (Dawn way)
        if (drawer && typeof drawer.renderContents === "function" && state && state.sections) {
          try {
            drawer.renderContents(state);
            setupDrawerMutationObserver();
            hookDrawerToggle();
            scheduleRender();
            return;
          } catch (e) {
            // fallback below
          }
        }

        return refreshCartUI(state);
      })
      .catch(function () {
        button.disabled = false;
      });
  });

  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-upsell-variant-select]");
    if (!select) return;
    updateUpsellPriceFromSelect(select);
  });

  /* ========= triggers ========= */

  hookDrawerToggle();

  document.addEventListener("shopify:section:load", function () {
    setupDrawerMutationObserver();
    hookDrawerToggle();
    scheduleRender();
  });

  ["cart-drawer:open", "cart:updated", "cart:refresh", "ajaxProduct:added", "cart:change"].forEach(function (evt) {
    document.addEventListener(evt, function () {
      scheduleRender();
    });
  });

  // Observe when upsells root appears/replaced (Dawn often re-renders drawer HTML)
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      (m.addedNodes || []).forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches("[data-cart-upsells-root]")) {
          setupDrawerMutationObserver();
          hookDrawerToggle();
          scheduleRender();
        } else if (node.querySelector && node.querySelector("[data-cart-upsells-root]")) {
          setupDrawerMutationObserver();
          hookDrawerToggle();
          scheduleRender();
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setupDrawerMutationObserver();
      hookDrawerToggle();
      scheduleRender();
    });
  } else {
    setupDrawerMutationObserver();
    hookDrawerToggle();
    scheduleRender();
  }
})();
